<script setup>
import { useStateStore } from '@/stores/state.store'
import ButtonDefault from './atoms/ButtonDefault.vue'
import ProductDisplay from '@/components/Shopify/ProductDisplay.vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import eventBus from '@/eventBus'
import { useCart } from '@/router/cart'
import { useShopify } from '@/stores/shopify'
import { onClickOutside } from '@vueuse/core'
import { storeToRefs } from 'pinia'

const { openCart } = useCart()
const shopify = useShopify()
const state = useStateStore()
const { selectedProduct } = storeToRefs(state)
const logo = '/home/img/wyrld-logo.png'

const productPanel = ref(null)

const close = () => {
  eventBus.$emit('product-panel-closed')
  state.popProduct()
}

onMounted(() => {
  eventBus.$on('cart-added-items', () => {
    openCart()
    close()
  })
})

onBeforeUnmount(() => {
  eventBus.$off('cart-added-items')
})

onClickOutside(productPanel, () => {
  if (selectedProduct.value != undefined) {
    close()
  }
})
</script>

<template>
  <div v-if="selectedProduct" class="product-panel" ref="productPanel">
    <div class="header">
      <div class="header__logo">
        <img :src="logo" width="100"/>
      </div>
      <div class="header__right">
        <ButtonDefault
          icon="Cart"
          icon-only
          class="cart__button"
          :badge="shopify.cartLines"
          @click="openCart"
        />
        <ButtonDefault icon="Close" icon-only @click="close" />
      </div>
    </div>
    <div class="product__container">
      <ProductDisplay :product="selectedProduct" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-panel {
  overscroll-behavior: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;

  width: 100dvw;
  max-width: 600px;
  height: 100dvh;
  overflow-y: auto;
  background-color: var(--clr-white);

  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .header {
    height: 60px;
    position: sticky;
    padding: 0 20px;
    width: 100%;
    z-index: 1000;
    top: 0;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);

    &__logo {
      position: fixed;
      left: 22px;
      top: 12px;
    }

    &__right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 32px;
      height: 100%;
    }
  }

  .product__container {
    position: relative;
  }
}
</style>
